"use client"

import Link from 'next/link'
import useSWR from 'swr'
import SvgIcon from '@components/shared/svg-icons/SvgIcon'
import { badgeText, unreadLabel, useUnread } from '@components/messages/unread'
import useRedirectBack from '@hooks/useRedirectBack'
import storage from '@utils/localStorage'
import checkLogin from '@utils/checkLogin'
import { LOGIN_PAGE, MESSAGES_PAGE } from '@constants/routes'

import styles from './SiteHeader.module.css'

const HOST = process.env.NEXT_PUBLIC_HOST
const className = `${styles.iconBtn} ${styles.desk}`

export default function HeaderChat () {
    const { data: user } = useSWR('user', storage)
    const { total } = useUnread()
    const [, setRedirect] = useRedirectBack()

    if (!checkLogin(user)) {
        return (
            <Link aria-label="Wiadomości" className={className} href={HOST + LOGIN_PAGE} onClick={() => setRedirect()} prefetch={false}>
                <SvgIcon name="chat" />
            </Link>
        )
    }

    return (
        <Link aria-label={unreadLabel(total)} className={className} href={HOST + MESSAGES_PAGE} prefetch={false}>
            <SvgIcon name="chat" />
            { Boolean(total) && <span aria-hidden="true" className={styles.count}>{badgeText(total)}</span> }
        </Link>
    )
}
